/* eslint-disable import/prefer-default-export */
import { apiClient, handleResponse } from './axios';

async function getStudentById(id) {
  try {
    const response = await apiClient.get(`/student/${id}`);
    const student = await handleResponse(response);
    return student;
  } catch (error) {
    return error.response;
  }
}

async function getStudents() {
  try {
    const response = await apiClient.get('/student/');
    const student = await handleResponse(response);
    return student;
  } catch (error) {
    return error.response;
  }
}

async function transferStudent(userId, companyId) {
  try {
    const response = await apiClient.get(`/student/transfer/${userId}/${companyId}`);
    const student = await handleResponse(response);
    return student;
  } catch (error) {
    return error.response;
  }
}

async function getTestsByStudent(studentId) {
  try {
    const response = await apiClient
      .get(`/test/user/all/${studentId}`);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return error.response;
  }
}

async function getProgressTrackerByStudent(studentId) {
  try {
    const response = await apiClient
      .get(`/progresstracker/${studentId}`);
    const data = await handleResponse(response);
    return data;
  } catch (err) {
    return err.response;
  }
}

async function getStudentsByCompany(companyId) {
  try {
    const response = await apiClient
      .get(`/student/company/${companyId}`);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return error.response;
  }
}

async function getRepeatStudents() {
  try {
    const response = await apiClient
      .get('/student/pending/repeat');
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return error.response;
  }
}

async function updateStudentRepeat(id, repeat) {
  try {
    const response = await apiClient.put(`/student/repeat/${id}`, { repeat });
    const student = await handleResponse(response);
    return student;
  } catch (error) {
    return error.response;
  }
}

async function deleteTest(id) {
  try {
    const response = await apiClient.delete(`/test/${id}`);
    const student = await handleResponse(response);
    return student;
  } catch (error) {
    return error.response;
  }
}

export const studentServices = {
  getStudentById,
  getStudents,
  getStudentsByCompany,
  getRepeatStudents,
  transferStudent,
  deleteTest,
  getProgressTrackerByStudent,
  getTestsByStudent,
  updateStudentRepeat,
};
